export enum ShippingOptionService {
    custom = 'App\\Services\\Shipping\\Custom',
    shippo = 'App\\Services\\Shipping\\Shippo',
    JGS = 'App\\Services\\Shipping\\JustGolfStuff',
}
